import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import SyfLoader from 'syf-component-library/ui/atoms/Loader/SyfLoader';
const LoadingWrapper = styled.div `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const Loading = () => (_jsx(LoadingWrapper, { "data-testid": "syf-loader", children: _jsx(SyfLoader, { size: 4.375 }) }));
export default Loading;
